module.exports = __webpack_public_path__ + "media/f93626f67f7343eca052a50763c5fb5c.0f008f4a.mp4";